export default {
    pathogen_2: 'All pathogens',
    pathogen_1: 'Acinetobacter baumannii',
    pathogen_55: 'Other Acinetobacter species',
    pathogen_58: 'Actinomyces spp.',
    pathogen_25: 'Adenovirus',
    pathogen_26: 'Aeromonas spp.',
    pathogen_61: 'Aspergillus spp.',
    pathogen_57: 'Burkholderia spp.',
    pathogen_28: 'Campylobacter spp.',
    pathogen_50: 'Candida spp.',
    pathogen_29: 'Chlamydia spp.',
    pathogen_3: 'Citrobacter spp.',
    pathogen_30: 'Clostridioides difficile',
    pathogen_69: 'Other Clostridioides species',
    pathogen_70: 'Coagulase-negative Staphylococcus',
    pathogen_67: 'Cryptococcus spp.',
    pathogen_31: 'Cryptosporidium spp.',
    pathogen_63: 'Cytomegalovirus',
    pathogen_27: 'Entamoeba histolytica',
    pathogen_4: 'Enterobacter spp.',
    pathogen_5: 'Enterococcus faecalis',
    pathogen_6: 'Enterococcus faecium',
    pathogen_59: 'Other Enterococcus species',
    pathogen_7: 'Escherichia coli',
    pathogen_32: 'Other Fungi',
    pathogen_54: 'Other Gram-negative bacteria',
    pathogen_60: 'Other Gram-positive bacteria',
    pathogen_10: 'Haemophilus influenzae',
    pathogen_66: 'Histoplasma spp.',
    pathogen_47: 'Influenza virus',
    pathogen_52: 'Other Klebsiella species',
    pathogen_11: 'Klebsiella pneumoniae',
    pathogen_34: 'Legionella spp.',
    pathogen_68: 'Leptospira spp.',
    pathogen_35: 'Listeria monocytogenes',
    pathogen_12: 'Morganella spp.',
    pathogen_71: 'Mumps',
    pathogen_62: 'Other mycobacterium species',
    pathogen_13: 'Mycobacterium tuberculosis',
    pathogen_36: 'Mycoplasma spp.',
    pathogen_24: 'Neisseria gonorrhoeae',
    pathogen_37: 'Neisseria meningitidis',
    pathogen_64: 'Non-polio enteroviruses',
    pathogen_38: 'Norovirus',
    pathogen_16: 'Proteus spp.',
    pathogen_17: 'Pseudomonas aeruginosa',
    pathogen_56: 'Other Pseudomonas species',
    pathogen_48: 'Respiratory syncytial virus',
    pathogen_42: 'Rotavirus',
    pathogen_14: 'Non-typhoidal Salmonella',
    pathogen_18: 'Salmonella enterica serovar Paratyphi',
    pathogen_19: 'Salmonella enterica serovar Typhi',
    pathogen_20: 'Serratia spp.',
    pathogen_21: 'Shigella spp.',
    pathogen_22: 'Staphylococcus aureus',
    pathogen_8: 'Group A Streptococcus',
    pathogen_9: 'Group B Streptococcus',
    pathogen_51: 'Other Streptococcus  species',
    pathogen_23: 'Streptococcus pneumoniae',
    pathogen_53: 'Toxoplasma spp.',
    pathogen_72: 'Treponema pallidum',
    pathogen_43: 'Vibrio cholerae',
    pathogen_65: 'Other viruses',
    pathogen_44: 'Viruses of LRI & meningitis',
    pathogen_39: 'Other pathogens in diarrhea',

    pathogen_10000: 'Amebiasis',
    pathogen_10001: 'Enteropathogenic escherichia coli',
    pathogen_10002: 'Enterotoxigenic escherichia coli',
    pathogen_10003: 'Providencia',
    pathogen_10004: 'None estimated',
    pathogen_10005: 'Klebsiella',
    pathogen_10006: 'Plasmodium falciparum and plasmodium vivax',
    pathogen_10007: 'Plasmodium falciparum',
    pathogen_10008: 'Plasmodium vivax',
};
